export enum MDC {
  CPID= 'CPId',
  CPCode= 'CPCode',
  CPName= 'CPName',
  Language= 'Language'
}
